export interface IFollowup{
    Id?: number;
    IdProyecto: number;
    PPresCodProy: string;
    TituloProyecto: string;
    CodigoSubvencion: string;
    IdFinanciador: string;
    Anio: string;
    OCTAVIAFechaInicio: string;
    OCTAVIAFechaFinalizacion: string;
    IdPais: string;
    IdRegion: string;
    IdLineaIntervencion: string;
    EstadoSubproyecto?: string;
    EstadoAnio?: string;
    EnEdicion?: boolean;
    Created: string;
}

export interface IFollowupBasicDataMasters {
    regions?: any;
    countries?: any;
    grantCodes?: any;
    interventionLines?: any;
    ffccFinancer?: any;
    ffrrFinancer?: any;
    allFinancers?: any;
    countriesAndRegions?: any;
    followupState?: any;
    followupDimensions?: any;
    measureUnits?: any;
    criterioDeExito?: any;
    frecuenciaDeMedicion?: any;
    strategicLine?: any;
    productsIndicator?: any;
    intermediateIndicatorResults?: any;
    counterpartType?: any;
    slep?: any;
    ageRange?: any;
    ruralities?: any;
    inPeriods?: any;
}

export interface IFollowupIndicators {
    indObjEspecificos?: any;
    indResEsperados?: any;
    indActividades?: any;
    indLineaPrincipal?: any;
    indLineaSecundaria?: any;
    indResInstitucionales?: any;
    indProInstitucionales?: any;
}

export interface IFollowupBeneficiaries {
    benByAge: any;
    benByLocation: any;
    benByRurality: any;
    benByResult: any;
    benByOverlap: any;
    benByGen: any;
    benBySubPr: any;
}

export interface IFollowupFinancial {
    finImplementers: any;
    finLocations: any;
    finAdts: any;
    finSdcs: any;
    finResults: any;
    finTotalsResults: any;
}

export interface ICommonFieldProps {
    fieldName: string,
    dimensionState?: string,
    indicatorType?: number,
    year?: number,
    fixed?: boolean
}

export interface IFollowupMigration {
    indLEPpal: Array<any>;
    indLESec:  Array<any>;
    indLEResI:  Array<any>;
    indLEProd:  Array<any>;
    indObj:  Array<any>;
    indResEsp:  Array<any>;
    indAct:  Array<any>;
    beneficiaries:  Array<any>;
    budgetImp:  Array<any>;
    budgetAct:  Array<any>;
    budgetLoc:  Array<any>;
    budgetADT:  Array<any>;
    budgetSDC:  Array<any>;
}
export class FollowupMigration implements IFollowupMigration{
    public indLEPpal: Array<any>;
    public indLESec:  Array<any>;
    public indLEResI:  Array<any>;
    public indLEProd:  Array<any>;
    public indObj:  Array<any>;
    public indResEsp:  Array<any>;
    public indAct:  Array<any>;
    public beneficiaries:  Array<any>;
    public budgetImp:  Array<any>;
    public budgetAct:  Array<any>;
    public budgetLoc:  Array<any>;
    public budgetADT:  Array<any>;
    public budgetSDC:  Array<any>;
    
    constructor(){
        this.indLEPpal = [];
        this.indLESec = [];
        this.indLEResI = [];
        this.indLEProd = [];
        this.indObj = [];
        this.indResEsp = [];
        this.indAct = [];
        this.beneficiaries = [];
        this.budgetImp = [];
        this.budgetAct = [];
        this.budgetLoc = [];
        this.budgetADT = [];
        this.budgetSDC = [];
    }
}